(function () {
  'use strict';
  /**
   * @ngdoc service
   * @name core.factory:ConfigService
   *
   * @description
   *
   */
  angular
    .module('core')
    .provider('ConfigService', ConfigServiceProvider);

  function ConfigServiceProvider($sessionStorageProvider) {
    //TODO: Move all constants that can be configurable here
    var defaultLocale = 'en';
    var serverId = '1';
    //var url = 'https://hgaa2012.comtrade.com/AuthorizedAPI.MNE/'; //NOTE: API MUST END WITH / 'http://WIZARD/API/';
    //var authorizationUrl = 'https://hgaa2012.comtrade.com/OAuthServer/oauth/authorize';
    //var url = 'https://195.66.186.100/AuthorizedAPI/';

    var url = 'https://ebank.addiko.me/api/';
    var authorizationUrl = 'https://ebank.addiko.me/OAuthServer/oauth/authorize';
    var logoutUrl = 'https://ebank.addiko.me/OAuthServer/oauth/logout';

    return {
      defaultLocale: defaultLocale,
      serverId: serverId,
      $get: function ($window) {
        var _tempStorage = JSON.parse($window.sessionStorage.getItem('ngStorage-credentials'));
        var _tempState = _tempStorage ? _tempStorage.state : undefined;

        var ConfigServiceBase = {};
        ConfigServiceBase.addQueryString = function addQueryString(uri, parameters) {
          var delimiter = (uri.indexOf('?') == -1) ? '?' : '&';
          for (var parameterName in parameters) {
            var parameterValue = parameters[parameterName];
            uri += delimiter + encodeURIComponent(parameterName) + '=' + encodeURIComponent(parameterValue);
            delimiter = '&';
          }
          return uri;
        };

        var host = window.location;
        var pathname = location.pathname.substring(0, location.pathname.lastIndexOf("/"));
        var defaultRedirectUrl = host.protocol + '//' + host.host + pathname + '/login.html';
        var iFrameUrl = host.protocol + '//' + host.host + pathname + '/hidden-auth-component.html';
        var hiddenAuthUrl = host.protocol + '//' + host.host + pathname + '/hidden-auth-component.html';

        if (_tempState == undefined) {
          _tempState = Math.random();
        }

        ConfigServiceBase.defaultLocale = defaultLocale; //Dejan: Dodao sam defaultLocale jer je bio undefined
        ConfigServiceBase.serverId = serverId;
        ConfigServiceBase.url = url;
        ConfigServiceBase.onBeforeLoadOn = true;
        ConfigServiceBase.testLocal = false;
        ConfigServiceBase.logoutTokenTimeout = 900000;
        ConfigServiceBase.googleMapsKey = 'AIzaSyBdXu0IUDIAsHYzMoapWw0qdO-hcH9vplM';
        ConfigServiceBase.refreshTokenTimeout = 1150000;
        ConfigServiceBase.iFrameUrl = iFrameUrl;
        ConfigServiceBase.clientId = 'eBank'; //TODO: Change this to real clientId
        ConfigServiceBase.defaultRedirectUrl = defaultRedirectUrl;//'http://localhost/Comtrade.Banking.WebAPI/Areas/Swagger/o2c.html'//defaultRedirectUrl;
        ConfigServiceBase.authorizationUrl = ConfigServiceBase.addQueryString(authorizationUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state': _tempState,
          'scope': 'BAO2000',
          'login_hint': 'username_password_sms_otp',
          'response_type': 'token'
        });
        ConfigServiceBase.refreshTokenAuthorizationUrl = ConfigServiceBase.addQueryString(authorizationUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': hiddenAuthUrl,
          'state': _tempState,
          'scope': 'BAO2000',
          'login_hint': 'username_password_sms_otp',
          'response_type': 'token'
        });
        ConfigServiceBase.logoutUrl = ConfigServiceBase.addQueryString(logoutUrl, {
          'client_id': ConfigServiceBase.clientId,
          'redirect_uri': ConfigServiceBase.defaultRedirectUrl,
          'state': _tempState,
          'scope': 'BAO2000',
          'login_hint': 'username_password_sms_otp',
          'response_type': 'token'
        });

        return ConfigServiceBase;
      }
    };
  }
}());
/*
* http://localhost:59468/OAuth/Authorize?client_id=7890ab
* &redirect_uri=http%3A%2F%2Flocalhost%3A38515%2FHome%2FSignIn&state=my-nonce&scope=bio%20notes&login_hint=ct_mtoken&response_type=token
* */
